import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconFlagWithTick({ color = '#000000', title, ...rest }: IconProps): ReactElement {
    return (
        <svg width='32' height='32' viewBox='0 0 32 32' {...rest} xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <g fill='none' fillRule='evenodd' transform='translate(-1268 -954)'>
                <g transform='translate(1268 958)'>
                    <polygon fill={color} points='2 24 0 24 0 0 2 0' />
                    <polygon fill={color} points='20 2 4 2 4 14 20 14 16 8.031' />
                    <g>
                        <rect fill='#fff' x='15' y='8' width='17' height='17' rx='8.5' />
                        <rect stroke={color} x='15.5' y='8.5' width='16' height='16' rx='8' />
                    </g>
                    <path d='M20.44,17.01 L22.65,19.22' stroke={color} strokeWidth='2' strokeLinecap='round' />
                    <path d='M22.65,19.22 L27.07,14.8' stroke={color} strokeWidth='2' strokeLinecap='round' />
                </g>
            </g>
        </svg>
    );
}
